import React from 'react';
import { Modal, Form, Input, Button, message } from 'antd';
import { useTranslation } from 'react-i18next';
import type { User } from '../../../types/users';

interface ChangePasswordModalProps {
  visible: boolean;
  user: User;
  onCancel: () => void;
  onSuccess: () => void;
}

const ChangePasswordModal: React.FC<ChangePasswordModalProps> = ({
  visible,
  onCancel,
  onSuccess,
}) => {
  const { t } = useTranslation(['users', 'common']);
  const [form] = Form.useForm();

  const handleSubmit = async () => {
    try {
      // TODO: Implement password change API call
      message.success(t('users:passwordChanged'));
      onSuccess();
    } catch (error: any) {
      message.error(error.message || t('common:error'));
    }
  };

  return (
    <Modal
      title={t('users:changePassword')}
      open={visible}
      onCancel={onCancel}
      footer={null}
    >
      <Form
        form={form}
        layout="vertical"
        onFinish={handleSubmit}
      >
        <Form.Item
          name="password"
          label={t('users:newPassword')}
          rules={[
            { required: true, message: t('users:passwordRequired') },
            { min: 6, message: t('users:passwordMinLength') }
          ]}
        >
          <Input.Password />
        </Form.Item>

        <Form.Item
          name="confirmPassword"
          label={t('users:confirmPassword')}
          dependencies={['password']}
          rules={[
            { required: true, message: t('users:confirmPasswordRequired') },
            ({ getFieldValue }) => ({
              validator(_, value) {
                if (!value || getFieldValue('password') === value) {
                  return Promise.resolve();
                }
                return Promise.reject(new Error(t('users:passwordsDoNotMatch')));
              },
            }),
          ]}
        >
          <Input.Password />
        </Form.Item>

        <Form.Item>
          <Button type="primary" htmlType="submit" block>
            {t('common:save')}
          </Button>
        </Form.Item>
      </Form>
    </Modal>
  );
};

export default ChangePasswordModal; 